<div class="customer-wrapper-footer">
  <mat-toolbar color="primary" class="footer">
    <mat-toolbar-row>
      <h6>Build Version {{ buildVersion }} Copyright &copy; Profit Rhino <span>{{ lastYear }}
        {{ currentYear }}</span></h6> 
    </mat-toolbar-row>
  </mat-toolbar>
</div>
